import React from "react"

interface TitleProps {
  title: string
  black?: string
  orange?: string
  grey?: string
  className?: string
  type?: "60" | "34" | "100" | "48" | "h1" | "h2" | "h3" | "h4"
}

function Title({ title, black, orange, grey, className, type }: TitleProps) {
  // Compose colored spans if color props are provided
  const coloredSpans = (
    <>
      {black && (
        <span className="flex font-oswald text-[--color-dark]">{black} </span>
      )}
      {orange && <span className="text-[--color-brand]">{orange} </span>}
      {grey && <span className="text-[--color-gray]">{grey} </span>}
    </>
  )

  let typeClass = ""
  if (type === "60") typeClass = "text-[60px]"
  else if (type === "34") typeClass = "text-[34px]"
  else if (type === "100") typeClass = "text-[100px]"
  else if (type === "48") typeClass = "text-[48px]"

  if (type === "h1") {
    return (
      <h1
        className={`w-11/12 font-oswald leading-tight text-[34px] xl:text-[72px] 3xl:text-[196px] uppercase font-semibold ${typeClass} ${
          className || ""
        }`}
      >
        {coloredSpans}
        {title}
      </h1>
    )
  }
  if (type === "h2") {
    return (
      <h2
        className={`font-oswald  leading-tight font-semibold    uppercase text-[24px] xl:text-[60px]  ${typeClass} ${
          className || ""
        }`}
      >
        {coloredSpans}
        {title}
      </h2>
    )
  }
  if (type === "34" || type === "h4") {
    return (
      <h3
        className={`font-oswald font-semibold ${typeClass} ${className || ""}`}
      >
        {coloredSpans}
        {title}
      </h3>
    )
  }
  // fallback to h2
  return (
    <h2
      className={`font-oswald font-semibold  uppercase ${typeClass} ${
        className || ""
      }`}
    >
      {coloredSpans}
      {title}
    </h2>
  )
}

export default Title
